<template>
    <div>
        <!-- <div class="main">
            <div class="wid">
                <div class="img">
                    <div style="height: 100%;width: 100vw;">
                        <img style="height: 100%;width: 100vw;" src="@/assets/img.png" fit="fill"></img>
                    </div>
                </div>
                <template v-for="(item, index) in text">
                    <div v-show="index == num"
                        style="position: fixed;top: 0;left: 0;width: 100%;padding: 4px 16px;background-color: rgba(253, 246, 236, 0.5);font-size: 15px;text-align: center;z-index: 999;">
                        <img :src="item.img" alt="" style="width: 20px;height: 20px;vertical-align: middle;">
                        <span style="vertical-align: middle;"> {{ item.title }} 已报名 1秒前</span>
                    </div>
                </template>
<div class="jump bottom-container-full">
    <button class="apply-entrance-button-single van-button van-button--default van-button--normal" @click="submit">
        <div class="van-button__content">
            <span class="van-button__text"> 点我免费领取课程 </span>
        </div>
    </button>
</div>
</div>
<div style="height: 14vh;">

</div>
</div> -->
    </div>
</template>
<script>
import axios from 'axios';
import head1 from '@/assets/head1.webp';
import head2 from '@/assets/head2.webp';
import head3 from '@/assets/head3.webp';
import head4 from '@/assets/head4.webp';
export default {
    data() {
        return {
            str: 6,
            num: 0,
            url: '',
            data: [],
            time: null,
            text: [
                {
                    img: head1,
                    title: '177****5575'
                },
                {
                    img: head2,
                    title: '153****4235'
                },
                {
                    img: head3,
                    title: '182****4878'
                },
                {
                    img: head4,
                    title: '133****5625'
                },
            ],
            show: false
        }
    },
    async mounted() {
        this.getGo()
        // this.search()
        // this.jumpTo()
        // this.getTime()
    },
    methods: {
        async getGo() {
            // window.location.href = 'https://work.weixin.qq.com/ca/cawcde837375cfaea6'
            try {
                const s = this.getShortUrl()
                let response = await axios.post('https://api.jiankangxuexi.com/patch/wechat_popularize_pub/get', { short_url: s });
                if (response.code === 1) {
                    // window.location.href = response.data.popularize_url;
                    window.location.replace(response.data.popularize_url);
                } else {
                    console.error('Unexpected response code:', response.data.code);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        getTime() {
            this.time = setInterval(() => {
                if (this.num >= 3) {
                    this.num = 0
                } else {
                    let i = this.num
                    this.num = this.str
                    setTimeout(() => {
                        this.num = i + 1
                    }, 10);
                }
            }, 2000);
        },
        getShortUrl() {
            // const currentUrl = window.location.href;
            // const hash = window.location.search;
            // const queryString = hash.split('?')[1];
            // const params = new URLSearchParams(queryString);
            // const shortUrl = params.get('s');
            // return shortUrl;

            const path = window.location.pathname;
            const suffix = path.substring(1);
            if (suffix === '') {
                return window.location.host;
            }
            return window.location.host + '/' + suffix;
        },
        async search() {
            try {
                const s = this.getShortUrl()
                let response = await axios.post('https://api.jiankangxuexi.com/patch/wechat_popularize_pub/get', { short_url: s });
                if (response.code === 1) {
                    this.url = response.data.popularize_url;
                    // this.data = response.data.popularize_img;
                } else {
                    console.error('Unexpected response code:', response.data.code);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        jumpTo() {
            // window.location.href = this.url;
            this.$confirm('即将离开企业微信打开其他应用', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.show = false
                window.location.href = this.url;
            }).catch(() => {
                this.show = true
            });
            setTimeout(() => {
                if (!this.show) {
                    window.location.href = this.url;
                }
            }, 5000)
        },
        submit() {
            window.location.href = this.url;
        }
    }
}
</script>
<style lang="scss" scoped>
.apply-entrance-button-single {
    font-size: 20px;
}

.apply-entrance-button-single,
.apply-entrance-button {
    background: #e90027;
    width: 60%;
    height: 50px;
    border-radius: 25px;
    color: #fff;
    font-weight: bolder;
    box-shadow: 0 3px 7px 0 #e9030f;
    animation: bounce .7s ease-in-out infinite alternate;
}

.van-button--normal {
    padding: 0 15px;
}

.van-button--default {
    border: 1px solid #ebedf0;
}

.van-button {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    /* height: 44px; */
    margin: 0;
    padding: 0;
    /* font-size: 16px; */
    line-height: 1.2;
    text-align: center;
    /* border-radius: 2px; */
    cursor: pointer;
    /* -webkit-transition: opacity .2s; */
    transition: opacity .2s;
    -webkit-appearance: none;
}

button {
    font: inherit;
    border-radius: 20px;
}

.van-button:before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background-color: #000;
    border: inherit;
    border-color: #000;
    border-radius: inherit;
    /* -webkit-transform: translate(-50%, -50%); */
    transform: translate(-50%, -50%);
    opacity: 0;
    content: " ";
}

@keyframes bounce {
    0% {
        -webkit-transform: scale(1.7);
        transform: scale(1.7);
    }

    50% {
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }

    100% {
        -webkit-transform: scale(1.7);
        transform: scale(1.7);
    }
}

.van-button__content {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    height: 100%;
}

.van-button__content:before {
    content: " ";
}

.bottom-container-full,
.privacy-protocol-container {
    display: flex;
    -webkit-box-direction: normal;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}







.animate {
    position: fixed;
    width: 100%;
    height: unset;
    bottom: 0;
    left: 0;
    z-index: 9;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: none;
    padding: 0;
    outline: none;
    margin: 0;
}

::v-deep .el-carousel__indicators {
    display: none !important;
}

::v-deep .el-carousel__arrow {
    display: none;
}

::v-deep .el-carousel__container {
    height: 100% !important;
}

.wid {
    width: 100%;
}

.main {
    /* display: flex;
    justify-content: center; */
}

.img {
    width: 100%;
    height: 100vh;
    background-color: #fff;
}

.jump {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 13vh;
    bottom: 0;
    /* background-color: transparent; */
    background-color: #fff;
    z-index: 99;
}

.animate-pulse {
    width: 70vw;
    height: 5vh;
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.3);
    }

    100% {
        transform: scale(1);
    }
}
</style>